export interface Achievement {
  id: string;
  emoji: string;
  name: string;
  description: string;
}

/** The ten achievements in display order. Ids, names, emojis and texts match the Flutter client and the server. */
export const ACHIEVEMENTS: readonly Achievement[] = [
  { id: 'newbie', emoji: '🌱', name: 'Newbie', description: 'Found your first item.' },
  { id: 'apprentice', emoji: '🔨', name: 'Apprentice', description: 'Found 10 items.' },
  { id: 'novice', emoji: '🧭', name: 'Novice', description: 'Found 50 items.' },
  { id: 'master', emoji: '🏆', name: 'Master', description: 'Found 100 items.' },
  { id: 'world_explorer', emoji: '🌍', name: 'World Explorer', description: 'Found 1,000 items.' },
  { id: 'long_walker', emoji: '🥾', name: 'Long Walker', description: 'Completed your first multi-part item.' },
  { id: 'hunter', emoji: '🏹', name: 'Hunter', description: 'Found an epic item.' },
  { id: 'legend', emoji: '👑', name: 'Legend', description: 'Found a legendary item.' },
  { id: 'trailblazer', emoji: '🚩', name: 'Trailblazer', description: 'Completed 10 multi-part items.' },
  { id: 'generous', emoji: '🎁', name: 'Generous', description: 'Dropped an item for other hunters to find.' },
];

/** The known achievements among `ids`, once each, in display order. Unknown ids are ignored. */
export function knownAchievements(ids: readonly string[]): Achievement[] {
  const have = new Set(ids);
  return ACHIEVEMENTS.filter((a) => have.has(a.id));
}
